import * as React from "react";
const SvgLead = props => <svg aria-hidden="true" className="Lead_svg__MuiSvgIcon-root" style={{
  fontSize: 14,
  color: "#000"
}} viewBox="0 0 24 24" {...props}><path d="M20 5.41 18.59 4 7 15.59V9H5v10h10v-2H8.41z" /></svg>;
export default SvgLead;